var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pagetype=='_order')?_c('order',{attrs:{"storeId":_vm.storeId,"config":_vm.config},on:{"ement":_vm.ement}}):_c('product',{attrs:{"storeId":_vm.storeId,"config":_vm.config},on:{"ement":_vm.ement}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ad44911c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/stock/record/record.vue
// module id = null
// module chunks = 